import { handleActions, combineActions } from "redux-actions";
import * as Immutable from "immutable";

import * as Actions from "./reportActions";
import {userLogoutReceived} from "../../../security";

const initialState: Immutable.Map<string, any> = Immutable.fromJS({
  isFetchingData: false,
  error: '',
});

//is action payload immutable?
export const reportReducer = handleActions(
  {
    [combineActions(Actions.printReportRequested)](state, action) {
      return state
        .set("isFetchingData", true)
        .set("error", '')
    },
    [combineActions(Actions.printReportFailed)](state, action) {
      return state
        .set("isFetchingData", false)
        .set("error", action.payload)
    },
    [combineActions(Actions.printReportReceived)](state, action) {
      return state
        .set("isFetchingData", false)
        .set("error", '')
    },
    [userLogoutReceived](state, action) {
      return initialState
    }
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/features/report/store/reportReducer.js